<template>
  <div class="container">
    <div class="first">
      <div class="first-text">
        <div class="title">
          <h1>Contrata gratis el talento<br> DEV que tu empresa<br> necesita </h1>
        </div>
        <div>
          <p class="text-header">
            Nuestra exclusiva red de contactos cuenta con más de 65.000
            desarrolladores en 12 países.
          </p>
          <p class="text-header">
            Solicita el perfil técnico que tu empresa necesita y selecciona los mejores candidatos para ti.
          </p>
        </div>
        <div class="btn-talent">
        <a href="https://ademass-profile-request.netlify.app/" class="add-talent" target="_blank">
          Contrata gratis talento en 2 minutos
        </a>

      </div>
      </div>
      <div class="img-div">
        <img src="/external/222.jpg" alt="img" />
      </div>
    </div>
  </div>
</template>

<script  setup>
</script>

<style scoped>
.container{
  margin-top: 150px;
}
.btn-talent{
  min-width: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-talent{
  min-width: 380px;
}
.first {
  display: flex;
  flex-direction: row;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}

@media screen and (max-width: 900px) {
  .btn-talent{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0!important;
  }
  .first {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .container {
    margin-top: 0;
    max-width: 95%;
    justify-content: center;
    margin-top: 0;
  }

  .first-text {
    width: 100%;
    margin-bottom: 20px; /* Añadiendo un margen inferior para separar del componente anterior */
  }

  .img-div {
    width: 100%; /* Cambiando a 100% para ocupar todo el ancho */
    max-width: 100%; /* Añadiendo un límite de ancho */
    overflow: hidden;
    margin-bottom: 20px; /* Añadiendo un margen inferior para separar del componente anterior */
  }


  .add-talent {
    margin-bottom: 20px;
    min-width: 250px;
    margin-left: 0;
    margin-right: 90px;
    text-align: center;
  }
}

.first-text {
  display: flex;
  flex-direction: column;
}


h1 {
  color: rgba(196, 207, 44, 1);
  font-family: Darker Grotesque;
  font-weight: 900;
  font-size: 60px;
  font-style: Black;
  line-height: 94.9999988079071%;
}

.text-header {
  color: rgba(39, 52, 68, 1);
  font-size: 24px;
  font-style: Medium;
  margin-right: 80px;
  font-size: 24px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;
}

.add-talent {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px;
  border-radius: 25px;
  color: white;
  background-color: rgba(196, 207, 44, 1);
  border: 2px solid rgba(196, 207, 44, 1);
  width: 300px;
  text-decoration: none;
  font-size: 24px;
  margin-top: 35px;
  font-family: Darker Grotesque;
  font-weight: 600;
}

.add-talent:hover {
  background-color: white;
  color: rgba(196, 207, 44, 1);
  border: 2px solid rgba(196, 207, 44, 1);
}

.frame-rectangle46 {
  top: 518px;
  left: 168px;
  width: 341px;
  height: 47px;
  position: absolute;

}

.img-div {
  width: 700px;
  overflow: hidden;
}

.img-div img {
  width: 100%;
  height: auto;
  display: block;
}</style>